<script type="text/jsx">
import _ from "lodash";
import Trial2paid from '@/plans/EVENT_SAAS/config/trial2paid';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import ConfigBase from '@/plans/EVENT_SAAS/config/base';
import { isFromZeConsumption } from '@/plans/EVENT_SAAS/helper/utils';
import { mapGetters } from 'vuex';

export default {
  mixins: [Trial2paid, planCommonMixin],
  components: {
    ConfigBase: {
      mixins: [ConfigBase, planCommonMixin],
      computed: { ...mapGetters(['planMapFlat', 'getSelectedPlans']) },
      mounted() {
        const saasPlan = _.filter(this.planMapFlat, (p) => p.type === this.planType && p.isSaas);
        if (saasPlan?.length === 0 || isFromZeConsumption()) {
          this.title =  `${this.$t('billing.planform.title.eventsaascore')} ${this.$t('billing.events.ppa.title')}`;
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>
